const NAMESPACE = 'DUCKS/ACCOUNT';

export default NAMESPACE;
